// extracted by mini-css-extract-plugin
export default {"modal-body":"offerCard_modal-body__oIhJR","active-day":"offerCard_active-day__YxNIc","slots-area":"offerCard_slots-area__QTtaP","blockMessage":"offerCard_blockMessage__rKMN4"};